// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1g2c5","description":"PatientConsentPreview_description__3YCD4"};